"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const intl_1 = require("@kyruus/intl");
const styles_1 = __importDefault(require("./styles"));
const messages_1 = __importDefault(require("../../lib/messages"));
const PhoneNumberLink = (props) => {
    // destructuring here to avoid type error when
    // importing in typescript files.
    const { phone, intl, onClick } = props;
    return (react_1.default.createElement(styles_1.default, { href: `tel:${phone}`, title: intl.formatMessage(messages_1.default.phoneNumberLinkTitle, {
            phone_number: phone
        }), onClick: onClick, "data-testid": "PhoneNumberLink" }, phone));
};
PhoneNumberLink.propTypes = {
    phone: prop_types_1.default.string.isRequired,
    /**
     * Injected by `injectIntl HOC`
     */
    intl: prop_types_1.default.shape({
        formatMessage: prop_types_1.default.func.isRequired
    }).isRequired,
    onClick: prop_types_1.default.func
};
exports.default = (0, intl_1.injectIntl)(PhoneNumberLink);
//# sourceMappingURL=PhoneNumberLink.js.map